<template>
  <el-select-tree
    @change="selectOne"
    :data="bankTree"
    :props="treeProps"
    v-model="selectID"
    :disabled="onlyOne || disabled"
    :default-expand-all="false"
    :check-strictly="true"
    placeholder="请选择机构"></el-select-tree>
</template>

<script>
import {treeDataTranslate} from '@/utils'
import httpUtil from "../../utils/httpUtil";

export default {
  name: 'bankSelect',
  data() {
    return {
      selectID: this.bankId,
      treeProps: {
        value: 'id',
        children: 'children',
        label: 'bankName'
      },
      onlyOne: false,
      bankTree: [],
      bankList: [],
    }
  },
  props: {
    bankId: [Number, String],
    disabled: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: null
    },
    parentId: {
      type: Number,
      default: null
    },
    areaId: {
      type: Number,
      default: null
    },

  },
  watch: {
    bankId: function (newVal) {
      this.selectID = newVal;
      if (newVal) {
        let current = this.bankList.filter((item) => item.id === newVal)
        if (current.length === 1) {
          this.$emit("update:bankType", current[0].bankType);
          this.$emit("update:level", current[0].level);
          this.$emit("update:parentId", current[0].parentId);
          this.$emit("update:areaId", current[0].areaId);
        }
      }
    },
    selectID: function (newVal) {
      this.$emit("update:bankId", newVal);
    }
  },
  created() {
    this.getBankCondition();
  },
  methods: {
    selectOne(val, item) {
      this.$emit("update:bankId", val);
      this.$emit('update:bankType', item.bankType);
    },
    async getBankCondition() {
      this.bankList = await httpUtil.get('/sys/bank/getSupportBanks');
      if (this.bankList != undefined && this.bankList.length === 1) {
        this.onlyOne = true
      }
      this.$store.commit('bank/setBank', this.bankList)
      this.bankTree = treeDataTranslate(this.bankList)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bank/bank-select.vue